
import { call, put, takeEvery } from 'redux-saga/effects';

import { ContentActionNotification } from '~commonInfra/contentActions/ContentActionNotification';

import { Messages } from '../../../codegen/Localize';
import { DataSources } from '../../../datasource/resources/Datasources';
import { EXTRACT_FAILURE_NOTIFICATION_OPT_IN_FAILURE, EXTRACT_FAILURE_NOTIFICATION_OPT_IN_REQUEST,
     EXTRACT_FAILURE_NOTIFICATION_OPT_IN_SUCCESS, EXTRACT_FAILURE_NOTIFICATION_OPT_OUT_FAILURE, EXTRACT_FAILURE_NOTIFICATION_OPT_OUT_REQUEST,
    EXTRACT_FAILURE_NOTIFICATION_OPT_OUT_SUCCESS, ExtractFailureNotificationAction
} from '../../../extractTask/actions/ExtractFailureNotificationActions';

function* handleOptIn(action: ExtractFailureNotificationAction) {
    try {
        yield call(DataSources.enableFailureNotification, action.id, action.contentType);
        yield put({ type: EXTRACT_FAILURE_NOTIFICATION_OPT_IN_SUCCESS, id: action.id });
        ContentActionNotification.displaySuccessToast(Messages.extractFailureNotificationOptedIn());
    } catch (error) {
        yield put({ type: EXTRACT_FAILURE_NOTIFICATION_OPT_IN_FAILURE, error });
    }
}

function* handleOptOut(action: ExtractFailureNotificationAction) {
    try {
        yield call(DataSources.disableFailureNotification, action.id, action.contentType);
        yield put({ type: EXTRACT_FAILURE_NOTIFICATION_OPT_OUT_SUCCESS, id: action.id });
        ContentActionNotification.displaySuccessToast(Messages.extractFailureNotificationOptedOut());
    } catch (error) {
        yield put({ type: EXTRACT_FAILURE_NOTIFICATION_OPT_OUT_FAILURE, error });
    }
}

export function* watchExtractFailureNotificationActions() {
    yield takeEvery(EXTRACT_FAILURE_NOTIFICATION_OPT_IN_REQUEST, handleOptIn);
    yield takeEvery(EXTRACT_FAILURE_NOTIFICATION_OPT_OUT_REQUEST, handleOptOut);
}
